// @ts-nocheck
import { shippingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingAddress";
import { orderDetailsSubTitle } from "@store/Themes/common/props/orderDetails";

Object.assign(shippingAddressStyles, {
    wrapper: orderDetailsSubTitle.wrapper,
    titleText: orderDetailsSubTitle.titleText,
});
